<div class="rate-listing-table">
    @if (visibilitySyncStatus) {
        <div class="rates-visibility-sync-banner"
             [class.rates-visibility-sync-banner--active]="visibilitySyncStatus.is_active"
             [class.rates-visibility-sync-banner--failed]="visibilitySyncStatus.status === 'failed'">
            @if (visibilitySyncStatus.is_active) {
                <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
            } @else {
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            }
            <div class="rates-visibility-sync-banner__content">
                <span>{{ visibilitySyncStatus.message }}</span>
                @if (visibilitySyncStatus.error_message) {
                    <span class="rates-visibility-sync-banner__error">{{ visibilitySyncStatus.error_message }}</span>
                }
            </div>
        </div>
    }

    <app-data-table [title]="title"
                    [columns]="columns"
                    [fetchDataFn]="loadData"
                    [exportDataFn]="exportData"
                    [filterOptionsData]="options"
                    [reloadEmitter]="reloadTable$"
                    [toolbarExtraTemplate]="rateTableToolbar"
                    [enableGlobalSearch]="true"
                    [globalFilterFields]="['district_name_mapped', 'agency_name_mapped']"
                    globalSearchPlaceholder="Search by district, agency"
                    defaultSortField="created_at"
                    defaultSortOrder="desc"
                    [exportable]="authService.hasPermission('rates.rates.export')">
    </app-data-table>
</div>

<ng-template #rateTableToolbar>
    @if (authService.hasPermission('rates.pqg_rates.create')) {
        <p-button size="small"
                  [outlined]="true"
                  icon="pi pi-upload"
                  label="Upload PQG rates"
                  (onClick)="pqgUploadRatedModalOpened = true">
        </p-button>
    }
</ng-template>

<p-dialog header="Upload PQG rates"
          [(visible)]="pqgUploadRatedModalOpened"
          (onHide)="onPqgUploadModalHide()"
          [modal]="true"
          [style]="{width: '50vw'}">
    <app-loader [loading]="modalLoading"></app-loader>
    <div class="flex flex-column gap-3">
        <p class="text-sm m-0 leading-normal">
            <span class="font-semibold">Expected columns: </span>
            @for (col of pqgRatesRequiredColumns; track col; let i = $index) {
                @if (i > 0) {
                    <span>, </span>
                }
                <span>{{ col }}</span><span class="text-red-600">*</span>
            }<span>, </span>{{ pqgRatesOptionalColumns.join(', ') }}
            <span class="text-muted-color">(optional)</span>.
        </p>
        <span class="text-sm m-0 leading-normal text-muted-color">Matching is case-insensitive; extra spaces in names are ignored.</span>

        @if (pqgUploadFileError) {
            <div class="text-sm text-red-600">{{ pqgUploadFileError }}</div>
        }
        @if (pqgUploadMissingColumns?.length && file) {
            <div class="text-sm text-red-600">
                <span class="font-semibold">Missing required columns: </span>
                <span>{{ (pqgUploadMissingColumns ?? []).join(', ') }}</span>
            </div>
        }

        <p-fileupload #pqgFileUpload
                      mode="advanced"
                      chooseLabel="Choose"
                      uploadLabel="Upload"
                      chooseIcon="pi pi-file"
                      name="file"
                      accept=".xlsx,.xls,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      [maxFileSize]="10000000"
                      [customUpload]="true"
                      [auto]="false"
                      (onSelect)="onPqgFileChosen()"
                      (onClear)="onPqgFileChosen()"
                      (uploadHandler)="onPqgRatesUpload($event)">
            <ng-template #empty>
                <div>Drag and drop a file here, then click Upload.</div>
            </ng-template>
        </p-fileupload>
    </div>
</p-dialog>
